// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2QVAn","expireSoon":"styles_expireSoon__22xAs"};